<template>
    <v-row style="padding-top: 0;" v-if="survey">
        <v-toolbar color="green">
            <v-toolbar-title>{{plant.name}} ({{survey.vegetationStage | vegetationStageText}})</v-toolbar-title>
            <v-spacer></v-spacer>
            <!--
            <v-btn text icon color="black darken-2" @click="onEdit">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            -->
            <v-btn text icon color="black darken-2" @click="onClose">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-tabs color="green" v-model="tab" centered grow>
            <v-tab>{{$t('nav.survey')}}</v-tab>
            <v-tab>{{$t('nav.plant')}}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item class="tab-item">
                <SurveyContext :plant="plant" :survey="survey"></SurveyContext>
            </v-tab-item>
            <v-tab-item class="tab-item">
                <PlantContext :plant="plant"></PlantContext>
            </v-tab-item>
        </v-tabs-items>
    </v-row>
</template>

<script>
    import {VegetationStages} from '../../_helpers';
    import PlantContext from '../plant/PlantContext'
    import SurveyContext from '../survey/SurveyContext'

    export default {
        name: 'MapContext',
        components: {
            PlantContext,
            SurveyContext
        },
        computed: {
            survey() {
                return this.$store.state.map.context
            },
            plant() {
                return this.$store.state.plant.plantList.find(plant => plant.uuid === this.survey.neophyte)
            }
        },
        data: () => ({
            tab: null
        }),
        filters: {
            vegetationStageText(enumValue) {
                let vegetationStage = VegetationStages.itemByValue(enumValue)
                return vegetationStage ? vegetationStage.text : this.survey.vegetationStage
            }
        },
        methods: {
            // onEdit() {
            //     this.$router.push({name: 'Survey', params: {surveyId: this.survey.uuid}})
            // },
            onClose() {
                this.$emit('context-close');
            }
        }
    }
</script>

<style lang="scss">
    div.tab-item {
        padding: 12px;
    }
</style>
